import {FC} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
import {useIsMobile} from "modules/utils";
import {Language} from "modules/enums";
import {BaseExternalLink} from "components/Common";
import banner from "assets/images/ads/banner-UNCOMPRESSED.jpg";
import bannerFr from "assets/images/ads/bannerFr-UNCOMPRESSED.jpg";
import bannerMb from "assets/images/ads/bannerMb-UNCOMPRESSED.jpg";
import bannerMbFr from "assets/images/ads/bannerMbFr-UNCOMPRESSED.jpg";

const Wrapper = styled.aside`
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 28px 0;
	padding: 0 20px;

	img {
		max-width: 100%;
	}
`;

const banners = {
	[Language.English]: banner,
	[Language.French]: bannerFr,
};

const mobileBanners = {
	[Language.English]: bannerMb,
	[Language.French]: bannerMbFr,
};

const links = {
	[Language.English]: "https://www.cfl.ca/tickets/",
	[Language.French]: "https://www.lcf.ca/billets/",
};

export const Ads: FC = () => {
	const {isMobile} = useIsMobile();
	const {i18n} = useTranslation();
	const {search} = useLocation();
	const lang = i18n.language;
	const src = (isMobile ? mobileBanners : banners)[lang as Language];
	const href = links[lang as Language];

	return (
		<Wrapper>
			<BaseExternalLink href={`${href}${search}`}>
				<img src={src} alt="" />
			</BaseExternalLink>
		</Wrapper>
	);
};
